import { get } from "lodash-es";
import { useUTLSettingsContext } from "../context/UTLSettingContext";
import { SettingModel } from "../reducers/UTLSettingsReducer";
import { getUTLSettings } from "../repositorie/MESF-frontend-Repositorie";

export const useSearchUTLSettings = ({
	onError,
}: { onError: (err: string) => void }) => {
	const {
		actions: { initSettings },
	} = useUTLSettingsContext();

	const searchUTLSettings = async () => {
		const res = await getUTLSettings();
		if (res.ok) {
			const settings = get(res, "data.tables[0].rows", []) as SettingModel[];
			initSettings(settings);
		} else {
			onError(res.message);
		}
	};
	return { searchUTLSettings };
};
